<div class="tooltip-container">
  <mat-checkbox
    [(ngModel)]="value"
    [indeterminate]="intermediate"
    [disabled]="isDisabled"
    (change)="valueChange.emit($event)"
    [labelPosition]="labelPosition"
  >
    @if (icon) {
      <i [nimbusIcon]="icon"></i>
    }
    {{ label }}
  </mat-checkbox>
  @if (warningMessage) {
    <nimbus-tooltip [text]="warningMessage"></nimbus-tooltip>
  }
</div>

@if (isErrorState()) {
  <mat-error>
    <i class="error-triangle" [nimbusIcon]="icons.EXCLAMATION_TRIANGLE"></i>
    <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
  </mat-error>
}
